import * as actionTypes from "../actions/actionTypes";
import { api ,auth} from "../../common/api-utils";
import { pathOr } from "ramda";
import { toast } from "react-toastify";
import axios from 'axios';


const getError = (res) =>
  pathOr("Something went wrong!", ["data", "errors", "detail"], res);

// List View actions
const getListViewRequest = () => ({
  type: actionTypes.LIST_VIEW_REQUEST,
});

const getGlobalSearchRequest = () => ({
  type: actionTypes.LIST_GLOBAL_SEARCH_REQUEST,
});

export const getGlobalSearchSuccess = (payload) => ({
  type: actionTypes.LIST_GLOBAL_SEARCH_SUCCESS,
  payload,
});

const getListViewSuccess = (payload, tab) => ({
  type: actionTypes.LIST_VIEW_SUCCESS,
  payload,
  tab,
});

const getListViewFailure = (error) => ({
  type: actionTypes.LIST_VIEW_FAILURE,
  error,
});

export const getListView = (
  tab,
  pageNo = 1,
  pageSize = 20,
  sort = '',
  filterQuery,
  folder_id = '',
) => async (dispatch) => {
  try {
    dispatch(getListViewRequest());
    let offset = '';
    if (tab === 'Emails') {
      offset = `&Emails2_EMAIL_offset=${pageNo * 20}`      
    }
    pageNo = pageNo + 1;
    let url = `/V8/layout/ListView/${tab}/1?page[number]=${pageNo}&page[size]=${pageSize}` + offset;
    if (sort) {
      url = `${url}&sort=${sort}`;
    }
    if (filterQuery) {
      //url = `${url}&${filterQuery.replace("%", "%25")}`;
      url = `${url}&${filterQuery}`;
    }
    if (folder_id && tab === 'Emails') {
      url = `${url}&folders_id=${folder_id}`;
    }
    const res = await api.get(url);
    if (res.ok) {
      // console.log("getListViewSuccess res.data", res.data);
      let sortField = sort.length?sort:pathOr("",["UserPreference","sortOrder"],res.data.data.templateMeta);
       sortField = sortField && (sortField.charAt(0)==='-')?sort.substring(1):sortField;
      let sortOrder = sortField && (sortField.charAt(0)==='-')?'desc':'asc';
      res.data.data.templateMeta.where = filterQuery;
      res.data.data.templateMeta.sort = sortField;
      res.data.data.templateMeta.sortOrder = sortOrder;
      res.data.data.templateMeta.page = pageNo;
      res.data.data.templateMeta.pageSize = pageSize;
      res.data.data.templateMeta.offset = offset;
      dispatch(getListViewSuccess(res.data, tab));
      if(folder_id)
      {
        return res;
      }
      return;
    }
    return dispatch(getListViewFailure(getError(res)));
  } catch (e) {
    dispatch(getListViewFailure(e));
  }
};

export const getGlobalSearch = (
  query_string,
  offset="0",
  module_offset="",
  config=[]
) => async (dispatch) => {
  try {
    if(!query_string) return;
    //console.log("queryString",query_string);
    let search_modules = Object.keys(config.unified_search_modules_display).filter((item,index)=>config.unified_search_modules_display[item].visible==true);
    let params = {};
    dispatch(getGlobalSearchRequest());
   if(config.defaultSearchEngine=='ElasticSearchEngine')
   {
      params = {
        "search-query-string":query_string.toString(),
        "search-query-size":"50",
        "search-query-from":offset.toString(),
        "search-engine":"ElasticSearchEngine",
        "action":"BasicSearchEngine"
    };
  }else{
    params={
      query_string:query_string.toString(),
      showGSDiv:"yes",
      skip_modules:"",
      search_modules:search_modules.toString()||"",
      action:"UnifiedSearch",
      advanced:"true",
      offset:offset.toString()
    };
    if(module_offset)
    {
      params.module_offset=module_offset;
    }
  }
    
    //console.log("params",newArr); 
  //  return;
    
    let url = `/V8/meta/globalsearch`;
    
    const res = await api.post(url,params);
    if (res.ok) {
      //console.log("result data",res.data);
      dispatch(getGlobalSearchSuccess(res.data));
      return res;
    }else{
      dispatch(getListViewFailure(getError(res)));
    }    
  } catch (e) {
    dispatch(getListViewFailure(e));
  }
};

export const getListViewActivities = (
  layout = null,
  tab = null,
  pageNo = 1,
  pageSize = 20,
  record = null,
  isFuture =0,
  sort = '',
  filterQuery,
) => async (dispatch) => {
  try {
    let offset = '';

    if(layout==='ActivityView'){
   
  
    let url = `/V8/layout/${layout}`;
    if(tab){
      url = `${url}/${tab}`;
    }else{
      url = `${url}/All/1`;
    }
    if(record){
      url = `${url}/${record}`;
    }
    url=`${url}?page[number]=${pageNo}&page[size]=${pageSize}&isFuture=${isFuture}`;
    const res = await api.get(url);
    if (res.ok) {
      return res.data;
    }
    return getError(res);
  }else{
    if (tab === 'Emails') {
      offset = `&Emails2_EMAIL_offset=${pageNo * 20}`
    }
    pageNo = pageNo + 1;
    let url = `/V8/layout/ListView/${tab}/1?page[number]=${pageNo}&page[size]=${pageSize}` + offset;
    if (sort) {
      url = `${url}&sort=${sort}`;
    }
    if (filterQuery) {
      //url = `${url}&${filterQuery.replace("%", "%25")}`;
      url = `${url}&${filterQuery}`;
    }
    const res = await api.get(url);
    if (res.ok) {
      return res.data;
    }
    return getError(res);
  }
    
  } catch (e) {
    return e;
  }
};


export const getPDFTemplates = (
  tab,
  relModule
) => async (dispatch) => {
  try {
    let url = `/V8/layout/Popup/${tab}/getTemplates/1?filter[type][eq]=${relModule}`;
    const res = await api.get(url);
    if (res.ok) {
      return res.data;
    }
  } catch (e) {
    return e;
  }
};


export const deleteRecordFromModule = async (module, id) => {
  try {
    return await api.delete(`/V8/module/${module}/${id}`);
  } catch (ex) {
    return ex;
  }
};

const getFilterConfigRequest = () => ({
  type: actionTypes.FILTER_CONFIG_REQUEST,
});

const getFilterConfigSuccess = (payload, module) => ({
  type: actionTypes.FILTER_CONFIG_SUCCESS,
  payload,
  module,
});

const getFilterConfigFailure = (error) => ({
  type: actionTypes.FILTER_CONFIG_FAILURE,
  error,
});

const getColumnChooserFieldsRequest = () => ({
  type: actionTypes.GET_COLUMNSCHOOSER_FIELDS_REQUEST
});

const getColumnChooserFieldsSuccess = (payload, module) => ({
  type: actionTypes.GET_COLUMNSCHOOSER_FIELDS_SUCCESS,
  payload,
  module,
})

const getColumnChooserFieldsFailure = (error) => ({
  type: actionTypes.GET_COLUMNSCHOOSER_FIELDS_FAILURE,
  error,
})

export const getFilterConfig = (module) => async (dispatch) => {
  try {
    dispatch(getFilterConfigRequest());
    const res = await api.get(`/V8/layout/Search/${module}/1`);
    if (res.ok) {
      dispatch(getFilterConfigSuccess(res.data, module));
      return;
    }
    return dispatch(getFilterConfigFailure(getError(res)));
  } catch (e) {
    dispatch(getFilterConfigFailure(e));
  }
};

export const getFilteredResults = (module, query) => async (dispatch) => {
  try {
    dispatch(getListViewRequest());
    const res = await api.get(`/V8/layout/ListView/${module}/1?${query}`);
    if (res.ok) {
      dispatch(getListViewSuccess(res.data, module));
      return;
    }
    return dispatch(getListViewFailure(getError(res)));
  } catch (e) {
    dispatch(getListViewFailure(e));
  }
};

export const getColumnChooserFields = (module) => async (dispatch) => {
  try {
    dispatch(getColumnChooserFieldsRequest());
    const res = await api.get(`/V8/layout/ColumnChooser/${module}/1`)
    if (res.ok) {
      dispatch(getColumnChooserFieldsSuccess(res.data, module));
      return;
    }
    return dispatch(getColumnChooserFieldsFailure(getError(res)));
  } catch (e) {
    dispatch(getColumnChooserFieldsFailure(e));
  }
}

// APIs related to relate field
export const getRelateFieldData = async (
  module,
  pageSize = 20,
  pageNo = 1,
  sort,
  query,
  reportsTo=null

) => {
  try {
    let url = `/V8/layout/Popup/${module}/1?page[size]=${pageSize}&page[number]=${pageNo}`;
    if (sort) {
      url = `${url}&sort=${sort}`;
    }
    if (query) {
      url = `${url}&${query}`;
    }
    if(reportsTo){
   
      url = `${url}&filter[reports_to_id][]=${reportsTo}`;   //&filter[status][]=Active
    }
    return await api.get(url);
  } catch (ex) {
    return ex;
  }
};

export const relateFieldSearch = async (module, query) => {
  try {
    return await api.get(`/V8/layout/Popup/${module}/1?page[size]=20&page[number]=1&${query}`);
  } catch (ex) {
    return ex;
  }
};
export const relatePopupCreateSubmit = async (data) => {
	try {
		data = JSON.stringify(data);
	  return await api.post(`/V8/module`, data);
	} catch (ex) {
	  return ex;
	}
};

export const setSelectedModule = (selectedTab) => ({
  type: actionTypes.SET_SELECTED_MODULE,
  payload: selectedTab,
});

export const resetModulesData = () => ({
  type: actionTypes.RESET_STORE,
});

// massupdate actions - customtoolbar / customtoolbarselect
export const massUpdate = async (data) => {
  try {
    return await api.patch(`/V8/layout/MassUpdate`, data);
  } catch (e) {
    return e;
  }
}

export const getMassUpdateForm = async (module) => {
  try {
    return await api.get(`/V8/layout/MassUpdate/${module}/1`)
  } catch (e) {
    return e;
  }
}

export const updateChoosedColumns = (module, columns) => async (dispatch) => {
  try {
    const res = await api.patch("/V8/layout/updateColumnChooser", {
      action: "updateColumnChooser",
      data: {
        type: module,
        displayColumns: columns,
      },
    });
    if (res.ok) {
      toast("column update success!")
      dispatch(getColumnChooserFields(module));
      dispatch(getListView(module,0,20,'',''));
    }
  } catch (e) {
    toast("something went wrong!");
  }
};

//get Audit view poup data
export const getAuditViewData = async (
  module,
  id,
  pageSize = 20,
  pageNo = 1,
  sort,
) => {
  try {
    let url = `/V8/layout/AuditView/${module}/${id}?page[size]=${pageSize}&page[number]=${pageNo}`;
    if (sort) {
      url = `${url}&sort=${sort}`;
    }
    return await api.get(url);
  } catch (ex) {
    return ex;
  }
};



//get In/Outbound Emails
export const getInboundOutboundEmails =  async (dispatch) => {
  try {
    let url = `/V8/emailsetting/listuseremailaccount?data[type]=InboundEmail`;
    return await api.get(url);
  } catch (ex) {
    return ex;
  }
};


//get Edit In/Outbound Emails
export const getEditInboundOutboundEmail =  async (type,id) => {
  let editType=type==='inbound'?'InboundEmail':'Outboundmail';
  let params={ "data":{

    "type": editType,
    "emailAccountId": id
}}
  try {
    let url = `/V8/emailsetting/editinboundemail`;
    return await api.post(url,params);
  } catch (ex) {
    return ex;
  }
};

//Delete  In/Outbound Emails
export const deleteInboundOutboundEmail =  async (type,id) => {
  let editType= (type==='inbound')?'InboundEmail':'OutboundEmailAccounts';
  let params={ "data":{

    "type": editType,
    "id": id,
    "attributes":{
      "deleted":1
    }
}}
  try {
    let url = `/V8/module`;
    return await api.patch(url,params);
  } catch (ex) {
    return ex;
  }
};




//get News Feeds
export const getNewsFeeds = (searchText,start,location) => async (dispatch) => {
  try {
  let params= {

    "q":encodeURI(searchText),
    "tbm":"nws",
    "location":encodeURI(location),
    "start":start

  };
    let url = `/V8/actionbutton/serpapi`;
   
    const res = await api.post(url,params);
    if (res.ok) {
      return res.data;
    }
    return getError(res);
  
    
  } catch (e) {
    return e;
  }
};

//get 360 Data
export const get360Data = (module,id) => async (dispatch) => {
  try {
  let params= {

    "module":module,
    "crm_id":id,

  };
    let url = `/V8/customer360`;
   
    const res = await api.post(url,params);
    if (res.ok) {
      return res.data;
    }
    return getError(res);
  
    
  } catch (e) {
    return e;
  }
};

//get 360 Data
export const get360PaginationData = (module,id,related_module,page) => async (dispatch) => {
  try {
  let params= {

    "module":module,
    "crm_id":id,
    "related_module": related_module,
    "page": page

  };
    let url = `/V8/c360pagination`;
   
    const res = await api.post(url,params);
    if (res.ok) {
      return res.data;
    }
    return getError(res);
  
    
  } catch (e) {
    return e;
  }
};

export const importRecords = async (data) => {
  try {
    return await api.post(`/V8/actionbutton/importfile`, data);
  } catch (e) {
    console.log(e);
    return e;
  }
}

export const importRecordsRevert = async (data) => {
  try {
    return await api.post(`/V8/actionbutton/importundo`, data);
  } catch (e) {
    console.log(e);
    return e;
  }
}
